import $public from '../../util/public.js'
export default {
	namespaced: true,
	state: {
		saleList:[],
		remark:'',
		total:{cash:0,living:0},
	},
	getters: {
	},
	mutations: {
		set_saleList(state, obj) {
			state.saleList = obj;
			let cash = 0;
			let living = 0;
			for(let i=0;i<obj.length;i++){
				if(obj[i].card_type.value==='1'){
					cash = $public.jia(cash, obj[i].price)
				}else if(obj[i].card_type.value==='2'){
					living = $public.jia(living, obj[i].price)
				}
			}
			state.total = {cash:cash,living:living}
		},
		set_remark(state, obj) {
			state.remark = obj;
		},
		reset(state){
			state.saleList = [];
			state.remark = '';
			state.total = {cash:0,living:0};
		},
	},
	actions: {
		
	},
};
